import React, {useEffect} from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { fetchPreviewCards } from '../store/resources';
import PreviewCard from './PreviewCard';


export default function PreviewCards() {
  const dispatch = useDispatch();
  const preview_cards = useSelector(state => state.previewCards);
  const domain = useSelector(state => state.app.current_domain);

  useEffect(() => {
    if (domain) {
      dispatch(fetchPreviewCards(domain));
    }
  }, [dispatch, domain]);

  return (
    <div className="container px-0">
      <div className="row">
        <div className="col-12">
          <h3>Link Previews</h3>
          <p>All messages will automatically assume the default link preview (set below) at time of posting.</p>
        </div>
        <div className="col-12">
          <h5><Link to="/preview_card/new" className="text-danger">Create link preview</Link></h5>
        </div>
        <div className="col-12">
          <Table striped bordered responsive>
            <thead>
              <tr>
                <th>Default?</th><th>Image</th><th>Name</th><th>Title</th><th>Description</th><th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
            {preview_cards.map(preview_card => (
              <PreviewCard
                preview_card={preview_card}
                key={preview_card.id}
              />
            ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
